package com.artvending.warden

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Canvas
import org.khronos.webgl.Uint8ClampedArray
import org.w3c.dom.*
import org.w3c.dom.mediacapture.MediaStream
import org.w3c.dom.mediacapture.MediaStreamConstraints

class JsScanner: Scanner() {
	var isActive = true // Переменная для отслеживания состояния
	var video: HTMLVideoElement? = null
	var canvas: CanvasRenderingContext2D? = null
	var canvasElement: HTMLCanvasElement? = null
	var stream: MediaStream? = null
	var successHandler: ((String) -> Unit)? = null
	
	
	override fun start() {
		isActive = true
	}
	
	override fun pause() {
		isActive = false
	}
	
	
	@Composable
	override fun ScannerView(onQrCodeScanned: (String) -> Unit) {
		Canvas({ id("canvas_"); style { width((window.innerWidth - settings.bigSpace.value).px); if (!started) opacity(0); borderRadius(12.px);property("box-shadow", "0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 4px rgba(0, 0, 0, 0.2)") } }) {
			LaunchedEffect(Unit) {
				start { decodedText ->
					log("Scan $decodedText")
					onQrCodeScanned(decodedText)
				}
			}
		}
	}
	
	fun start(successHandler: (String) -> Unit) {
		this.successHandler = successHandler
		isActive = true
		
		try {
			if (video == null)
				video = document.createElement("video") as HTMLVideoElement
			
			canvasElement = document.getElementById("canvas_") as HTMLCanvasElement
			val canvasElement = canvasElement
			canvas = js("canvasElement.getContext(\"2d\", { willReadFrequently: true });") as CanvasRenderingContext2D
			
			window.navigator.mediaDevices.getUserMedia(MediaStreamConstraints(video = js("{ facingMode: \"environment\"}")))
				.then { stream: MediaStream ->
					this.stream = stream
					video!!.srcObject = stream
					video!!.setAttribute("playsinline", "true") // чтобы iOS Safari не открывал fullscreen
					video!!.play()
					
					started  = true
					
					window.requestAnimationFrame { tick() }
				}.catch { throwable ->
					er("Scanner error: $throwable")
				}
		} catch (e: Exception) {
			er("Error starting QR scanner: $e")
		}
	}
	
	
	fun drawLine(begin: dynamic, end: dynamic, color: String) {
		val canvas = canvas
		
		if (canvas != null) {
			canvas.beginPath()
			canvas.moveTo(begin.x as Double, begin.y as Double)
			canvas.lineTo(end.x as Double, end.y as Double)
			canvas.lineWidth = 4.0
			canvas.strokeStyle = color
			canvas.stroke()
		}
	}
	
	fun tick() {
		try {
			if (isActive) {
				val video = video
				val canvasElement = canvasElement
				val canvas = canvas
				
				if (video != null && canvasElement != null && canvas != null) {
					if (video.readyState == HTMLMediaElement.HAVE_ENOUGH_DATA.toShort()) {
						canvasElement.hidden = false
						canvasElement.height = video.videoHeight
						canvasElement.width = video.videoWidth
						canvas.drawImage(video, 0.0, 0.0, canvasElement.width.toDouble(), canvasElement.height.toDouble())
						val imageData = canvas.getImageData(0.0, 0.0, canvasElement.width.toDouble(), canvasElement.height.toDouble())
						val code = js("jsQR(imageData.data, imageData.width, imageData.height, { inversionAttempts: 'dontInvert' })")
						
						if (code != null) {
							drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58")
							drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58")
							drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58")
							drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58")
							log(code.data)
							stop()
							successHandler?.invoke(code.data)
						}
					}
				}
				window.requestAnimationFrame { tick() }
			}
		} catch (e: Exception) {
			er("Error starting QR scanner: $e")
		}
	}
	
	
	fun stop() {
		log("STOPP")
		isActive = false // Останавливаем процесс
		video?.pause() // Останавливаем воспроизведение видео
		
		// Останавливаем все треки (видео/аудио)
		stream?.getTracks()?.forEach { track ->
			track.stop()
		}
		
		started = false
	}
}


external fun jsQR(data: Uint8ClampedArray, width: Int, height: Int, options: dynamic): dynamic